import type { MealType } from './types';

export const DEFAULT_MEAL_TYPES: MealType[] = [
  'breakfast',
  'morning_tea',
  'lunch',
  'afternoon_tea',
  'dinner',
  'snack',
];

export const MS_IN_DAY = 24 * 60 * 60 * 1000;

